export const SurveyScoreInformation = [
  {
    label: '0',
    value: 0,
    color: '#EB5757',
  },
  {
    label: '1',
    value: 1,
    color: '#EB5757',
  },
  {
    label: '2',
    value: 2,
    color: '#EB5757',
  },
  {
    label: '3',
    value: 3,
    color: '#EB5757',
  },
  {
    label: '4',
    value: 4,
    color: '#EB5757',
  },
  {
    label: '5',
    value: 5,
    color: '#EB5757',
  },
  {
    label: '6',
    value: 6,
    color: '#EB5757',
  },
  {
    label: '7',
    value: 7,
    color: '#FFC101',
  },
  {
    label: '8',
    value: 8,
    color: '#FFC101',
  },
  {
    label: '9',
    value: 9,
    color: '#1DD699',
  },
  {
    label: '10',
    value: 10,
    color: '#1DD699',
  },
] as const;
